export const AppName = process.env.REACT_APP_NAME;

export const baseApiUrl = process.env.REACT_APP_BASE_API_URL

// keycloak authentication
export const keyCloakConfig = {
    realm: process.env.REACT_APP_AUTH_REALM,
    clientId: process.env.REACT_APP_CLIENT_ID,
    idpHint: process.env.REACT_APP_IDP_HINT,
    url: process.env.REACT_APP_KEYCLOAK_URL
}

export const contactSurveyUrl = process.env.REACT_APP_CONTACT_SERVEY_URL
export const contactFaqUrl = process.env.REACT_APP_CONTACT_FAQ_URL

// base url for files & medias
export const fileBaseUrl = process.env.REACT_APP_FILE_BASE_URL

export const supportMailUrl = "support@hypercept-ga.com"